import React from 'react';
import Icon from '@ant-design/icons';

const CommentsIllustrationSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 176 176" strokeWidth="1">
        <path d="M34.07,161.16v-24.55h-2.07c-9.43,0-17.1-7.67-17.1-17.1V41.66c0-9.43,7.67-17.1,17.1-17.1h112.58c9.43,0,17.1,7.67,17.1,17.1v77.85c0,9.43-7.67,17.1-17.1,17.1H63.03l-28.97,24.55ZM32,25.66c-8.82,0-16,7.18-16,16v77.85c0,8.82,7.18,16,16,16h3.17v23.27l27.46-23.27h81.95c8.82,0,16-7.18,16-16V41.66c0-8.82-7.18-16-16-16H32Z" />
        <circle cx="63.39" cy="81.16" r="7.3" opacity="0.08" />
        <path d="M63.39,89.01c-4.33,0-7.85-3.52-7.85-7.85s3.52-7.85,7.85-7.85,7.86,3.52,7.86,7.85-3.52,7.85-7.86,7.85ZM63.39,74.4c-3.72,0-6.75,3.03-6.75,6.75s3.03,6.75,6.75,6.75,6.75-3.03,6.75-6.75-3.03-6.75-6.75-6.75Z" />
        <circle cx="89.08" cy="81.16" r="7.3" opacity="0.08" />
        <path d="M89.08,89.01c-4.33,0-7.86-3.52-7.86-7.85s3.52-7.85,7.86-7.85,7.85,3.52,7.85,7.85-3.52,7.85-7.85,7.85ZM89.08,74.4c-3.72,0-6.75,3.03-6.75,6.75s3.03,6.75,6.75,6.75,6.75-3.03,6.75-6.75-3.03-6.75-6.75-6.75Z" />
        <circle cx="114.77" cy="81.16" r="7.3" opacity="0.08" />
        <path d="M114.77,89.01c-4.33,0-7.85-3.52-7.85-7.85s3.52-7.85,7.85-7.85,7.85,3.52,7.85,7.85-3.52,7.85-7.85,7.85ZM114.77,74.4c-3.72,0-6.75,3.03-6.75,6.75s3.03,6.75,6.75,6.75,6.75-3.03,6.75-6.75-3.03-6.75-6.75-6.75Z" />
    </svg>
);

const CommentsIllustrationIcon = (props) => {
    return <Icon component={ CommentsIllustrationSvg } className={ props.className } style={ props.style } />;
};

export default CommentsIllustrationIcon;
